import { render, staticRenderFns } from "./RetailerComposeMessageModal.vue?vue&type=template&id=c91f653e&scoped=true"
import script from "./RetailerComposeMessageModal.vue?vue&type=script&lang=js"
export * from "./RetailerComposeMessageModal.vue?vue&type=script&lang=js"
import style0 from "./RetailerComposeMessageModal.vue?vue&type=style&index=0&id=c91f653e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91f653e",
  null
  
)

export default component.exports